<template lang="pug">
div
  .columns
    item-col.py-2.col-auto(label='Tipo edificação', :value='area.tipo')
    .column
    item-col.py-2.col-auto(label='Sequencia', :value='area.sequencia')
    .column
    item-col.py-2.col-auto(label='Situação', :value='area.situacao')
    .column
    item-col.py-2.col-auto(label='Área', :value='area.area | currency')
    .column
    item-col.py-2.col-auto(label='Principal', :value="area.principal ? 'Sim' : 'Não'")
    .column
    item-col.col-auto(label='Vistoria status', :value='area.vistoria_status')
    item-col.py-2.col-12(label='Descrição', :value='area.descricao' v-if='area.descricao')
  .pt-2(v-if='area.itens && area.itens.length')
    .columns
      item-col.py-2.col-auto(:label='item.campo', :value='item.resposta' v-for='(item, k) in area.itens' :key='k')
</template>

<script>
export default {
  props: {
    area: { type: Object, required: true },
  },
}
</script>
